import React, { createContext, useContext, useState } from 'react';
import { useEditing } from '../../MarkdownEditor/Lexical/hooks';
import { UnsavedConfirmationModal } from '../FileSystem/Modals/UnsavedConfirmationModal';
import { useSelectedTemplatingItem } from '../hooks';
import { TemplatingItem } from '../models';

const SwitchToTemplatingItemContext = createContext<{
  switchToTemplatingItem: (templatingItem: TemplatingItem) => void;
}>({
  switchToTemplatingItem: () => {
    void 0;
  },
});

export const SwitchToTemplatingItemProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const {
    isSelected,
    setSelectedTemplatingItemId,
    selectedTemplatingItemQuery: { data: selectedTemplatingItem },
  } = useSelectedTemplatingItem();

  const { isEditing } = useEditing();

  const [pendingTemplatingItemChange, setPendingTemplatingItemChange] =
    useState<string | null>(null);

  const handleDismissTemplatingItemChange = () => {
    setPendingTemplatingItemChange(null);
  };

  const handleConfirmTemplatingItemChange = () => {
    setSelectedTemplatingItemId(pendingTemplatingItemChange);
    setPendingTemplatingItemChange(null);
  };

  const switchToTemplatingItem = (templatingItem: TemplatingItem) => {
    if (isSelected(templatingItem)) {
      return;
    } else if (selectedTemplatingItem?.type === 'template' && isEditing) {
      setPendingTemplatingItemChange(templatingItem.id);
    } else {
      setSelectedTemplatingItemId(templatingItem.id);
    }
  };

  return (
    <SwitchToTemplatingItemContext.Provider
      value={{
        switchToTemplatingItem,
      }}
    >
      {children}
      <UnsavedConfirmationModal
        isOpen={Boolean(pendingTemplatingItemChange)}
        onDismiss={handleDismissTemplatingItemChange}
        onConfirm={handleConfirmTemplatingItemChange}
      />
    </SwitchToTemplatingItemContext.Provider>
  );
};

export const useSwitchToTemplatingItem = () => {
  return useContext(SwitchToTemplatingItemContext);
};
